import http from '../../utils/fetch';
export default {
    selectPage(query) {
        return http({
            url: '/api/swyl/v1/demo/bscSupplierRegionCompare/selectPage',
            method: 'post',
            params: query
        });
    },
    selectById(query) {
        return http({
            url: '/api/swyl/v1/demo/bscSupplierRegionCompare/selectById?id='+query,
            method: 'post',
        });
    },
    deleteList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscSupplierRegionCompare/deleteList',
            method: 'post',
            data: query
        });
    },
    updateById(query) {
        return http({
            url: '/api/swyl/v1/demo/bscSupplierRegionCompare/updateById',
            method: 'post',
            params: query
        });
    },
    selectByUserName(query){
        return http({
            url: '/api/swyl/v1/demo/bscSupplierRegionCompare/selectByUserName?customerName='+ query,
            method: 'post',
            //params: query
        });
    },
    //批量冻结
    freezeList(query){
        return http({
            url: '/api/swyl/v1/demo/bscSupplierRegionCompare/freezeList',
            method: 'post',
            data: query
        });
    },

    //批量解冻
    thawList(query){
        return http({
            url: '/api/swyl/v1/demo/bscSupplierRegionCompare/thawList',
            method: 'post',
            data: query
        });
    },






    selectProductPage(query) {
        return http({
            url: '/api/swyl/v1/demo/bscSupplierProductCompare/selectPage',
            method: 'post',
            params: query
        });
    },
    selectProductById(query) {
        return http({
            url: '/api/swyl/v1/demo/bscSupplierProductCompare/selectById?id='+query,
            method: 'post',
        });
    },
    selectByProduct(query){
        return http({
            url: '/api/swyl/v1/demo/bscSupplierProductCompare/selectByProduct?prodcode='+ query,
            method: 'post',
            //params: query
        });
    },
    updateByProductId(query) {
        return http({
            url: '/api/swyl/v1/demo/bscSupplierProductCompare/updateById',
            method: 'post',
            data: query
        });
    },
    deleteProductList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscSupplierProductCompare/deleteList',
            method: 'post',
            data: query
        });
    },
    selectByAreaId(query) {
        return http({
            url: '/api/swyl/v1/demo/bscSupplierRegionCompare/selectByAreaId?areaId='+query,
            method: 'post',
        });
    },
    getShouhPrice(query) {
        return http({
            url: '/api/swyl/v1/demo/bscSupplierProductCompare/getShouhPrice',
            method: 'post',
            params: query
        });
    },
    getSupplierByPro(query) {
        return http({
            url: '/api/swyl/v1/demo/bscSupplierProductCompare/getSupplierByPro',
            method: 'post',
            params: query
        });
    },
}